const InputGroup = ({label, description, children, style}) => {
  return (
      <div className="flex-col gap-2 bg-white border rounded-[8px]" style={style}>
          <div className="border-b" style={{padding: "16px 24px"}}>
              <div className="font-bold text-gray-900 font-16px">
                  {label}
              </div>
              <p className="text-gray-500 text-sm">{description}</p>
          </div>
          <div style={{padding: "16px 24px"}}>
              {children}
          </div>
      </div>
  );
};

export default InputGroup;
